export const AMOUNTS = ["£10k", "£25k", "£50k", "£100k", "£250k", "£1m+"];
export const PURPOSES = ["Cash flow", "Equipment", "Expansion", "Stock / inventory", "Refinance", "Other"];
export const TRADING = ["< 1 year", "1–2 years", "3–5 years", "5+ years"];
export const REFERENCES = ["James", "Micheal", "Sandra", "Willson", "Areej"];
export const HOMEOWNER_OPTIONS = ["Yes", "No"];

export const inputCls =
  "w-full bg-transparent border-b-2 border-[#052F24]/15 focus:border-[#052F24] outline-none py-3 text-lg font-light text-[#052F24] placeholder:text-[#052F24]/35 transition-colors";

export const stepVariants = {
  enter: { opacity: 0, x: 40 },
  center: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

export const INITIAL_FORM_STATE = {
  loan_amount: "",
  loan_purpose: "",
  trading_time: "",
  annual_turnover: "",
  monthly_sales: "",
  homeowner: "",
  full_name: "",
  business_name: "",
  company_number: "",
  company_address: "",
  email: "",
  phone: "",
  referred_by: "",
  packager: "",
};
